import React, { useState } from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import LoadingButton from "../../../../components/LoadingButton";
import { callAPI } from "../../../../lib/common";
import { getAccessCodeError } from "../../../lib/accessCodeError";
import { reportSubjects } from "@/react/Webshop/CopyrightAcknowledgement/copyrightAcknowledgement";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { useHistory } from "react-router";
import Box from "@mui/material/Box";
import WarningLastSubjectNotSelectedDialog from "../../../Components/WarningLastSubjectNotSelectedDialog";

export default function AddPictureSet() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [warning, setWarning] = useState(null);
  const { update } = usePictureSets();
  const history = useHistory();

  const addPictureSet = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    callAPI(
      "/ajax/prophoto/add_picture_set_by_code.php?code=" +
        encodeURIComponent(code),
    )
      .then((result) => {
        // Previews of the new subject wait for the copyright acknowledgement.
        reportSubjects(result.copyrightAcknowledgementSubjects);
        if (result.error || result.valid === false) {
          setError(getAccessCodeError(result, t));
          setIsLoading(false);
        } else if (result.warning) {
          setIsLoading(false);
          setWarning(result.warning);
        } else if (result.redirect) {
          document.location.href = result.redirect;
        } else {
          update();
          history.push("/my-account/new-set");
        }
      })
      .catch((err) => {
        setError(getAccessCodeError(err, t));
        setIsLoading(false);
      });
  };

  const handleOk = () => {
    setCode("");
    setError("");
    setWarning(null);
  };

  if (warning) {
    return (
      <WarningLastSubjectNotSelectedDialog
        subject={warning.payload.subject}
        handleOk={handleOk}
      />
    );
  }

  return (
    <MobilePage>
      <Box mb={4}>
        <PageHeader>
          <Trans>Add picture set</Trans>
        </PageHeader>
      </Box>
      <Container maxWidth="xs">
        <Box mb={4}>
          <Trans>Enter you image code below to add a new picture set.</Trans>
        </Box>

        <form onSubmit={addPictureSet}>
          <Box mb={4}>
            <FormControl fullWidth>
              <TextField
                name="code"
                variant="outlined"
                label={t("Enter image code here")}
                autoFocus
                onChange={(e) => setCode(e.target.value)}
                error={!!error}
                helperText={error}
                fullWidth={true}
              />
            </FormControl>
          </Box>
          <LoadingButton
            isLoading={isLoading}
            color="primary"
            type="submit"
            disabled={code.length < 5}
            fullWidth
          >
            <Trans>Add picture set</Trans>
          </LoadingButton>
        </form>
      </Container>
    </MobilePage>
  );
}
